
import imgEmptyNhanVien from 'assets/images/img_emptyview_user.png';
import AgencyHelper from 'features/Agency/agencyHelper';
import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import agencySaleHelper from 'features/DealerReconciliationReport/agencySaleHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import DropdownTableConfigColumn from 'general/components/DropdownTableConfigColumn';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown, { KTBSDropdownDirections } from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
  KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomDateRangePicker, { dateFilter, getDateFilterOption } from 'general/components/Others/CustomDateRangePicker';
import EmptyView from 'general/components/Others/EmptyView';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import DialogTransactionDetailView from '../DialogTransactionDetailView';
import PropTypes from 'prop-types';
import KTRadio, { KTRadioType } from 'general/components/OtherKeenComponents/KTFormControls/KTRadio';
import ToastHelper from 'general/helpers/ToastHelper';
import ChargeHelper from 'features/Charge/chargeHelper';
import agencyCommissionApi from 'api/agencyCommissionApi';
import * as ExcelJS from 'exceljs';

TransactionHistoryView.propTypes = {
  agencyRole: PropTypes.string.isRequired,
  transactionList: PropTypes.array,
  transactionTotal: PropTypes.number,
  filter: PropTypes.object,
  onFilterChanged: PropTypes.func,
  agencyDetail: PropTypes.object,
  showFullUI: PropTypes.bool,
};

const defaultColumnIds = ['TRANSACTION_CODE', 'TRANSACTION_TYPE', 'BANK_BENEFICIARY', 'BANK_ACCOUNT', 'BANK_NAME', 'TIME', 'AMOUNT', 'BALANCE', 'DESCRIPTION', 'STATUS', 'REQUIRED_TIME', 'PAID_TIME'];

function TransactionHistoryView(props) {
  // MARK: ---- params ----
  const { t } = useTranslation();
  const router = useRouter();
  const { agencyRole, transactionList, transactionTotal, filter, onFilterChanged, agencyDetail, showFullUI = false } = props;
  const { user } = useSelector((state) => state.auth);
  const transactionTypeOptions = useMemo(() => {
    return [
      {
        name: 'Tất cả',
        value: '',
      },
      {
        name: 'Cộng tiền',
        value: agencyRole,
      },
      {
        name: 'Rút tiền',
        value: 'WITHDRAW',
      },
    ];
  }, [agencyRole]);

  const fullColumns = useMemo(() => {
    return [
      {
        id: 'TRANSACTION_CODE',
        name: <span className="letter-spacing-unset font-weight-bolder"
          style={{
            fontSize: 12,
            color: AppColors.gray[900],
          }}
        >{t('Mã giao dịch')}</span>,
        minWidth: '130px',
        selector: (row) => row?.agencyTransactionCode ?? row?.agencyTransactionId,
        style: tableStyle?.columns?.link,
        sortable: false,
      },
      {
        id: 'TRANSACTION_TYPE',
        name: <span className="letter-spacing-unset font-weight-bolder"
          style={{
            fontSize: 12,
            color: AppColors.gray[900],
          }}
        >{t('Loại giao dịch')}</span>,
        selector: (row) => {
          return row?.forRole
            ? row.forRole === 'WITHDRAW'
              ? 'Rút tiền'
              : 'Cộng tiền'
            : ''
        },
        minWidth: '130px',
        sortable: false,
      },
      {
        id: 'DESCRIPTION',
        name: <span className="letter-spacing-unset font-weight-bolder"
          style={{
            fontSize: 12,
            color: AppColors.gray[900],
          }}
        >{t('Mô tả')}</span>,
        selector: (row) => {
          return row?.description
        },
        minWidth: '500px',
        sortable: false,
      },
      {
        id: 'BANK_BENEFICIARY',
        name: <span className="letter-spacing-unset font-weight-bolder"
          style={{
            fontSize: 12,
            color: AppColors.gray[900],
          }}
        >{t('Người thụ hưởng')}</span>,
        selector: (row) => {
          return row?.payment?.bankBeneficiary
        },
        minWidth: '200px',
        sortable: false,
      },
      {
        id: 'BANK_ACCOUNT',
        name: <span className="letter-spacing-unset font-weight-bolder"
          style={{
            fontSize: 12,
            color: AppColors.gray[900],
          }}
        >{t('Tài khoản thụ hưởng')}</span>,
        selector: (row) => {
          return row?.payment?.bankAccount
        },
        minWidth: '200px',
        sortable: false,
      },
      {
        id: 'BANK_NAME',
        name: <span className="letter-spacing-unset font-weight-bolder"
          style={{
            fontSize: 12,
            color: AppColors.gray[900],
          }}
        >{t('Ngân hàng')}</span>,
        selector: (row) => {
          return row?.payment?.bankName
        },
        minWidth: '200px',
        sortable: false,
      },
      {
        id: 'AMOUNT',
        name: (
          <div className='w-100'>
            <div className="letter-spacing-unset font-weight-bolder"
              style={{
                fontSize: 12,
                color: AppColors.gray[900],
              }}
            >{t('Số tiền')}</div>
            <div className="letter-spacing-unset font-weight-bold"
              style={{ color: AppColors.gray[700] }}
            >
              VNĐ
            </div>
          </div>
        ),
        selector: (row) => {
          return row?.forRole
            ? row.forRole === 'WITHDRAW'
              ? Utils.formatNumber(row?.amount)
              : '+' + Utils.formatNumber(row?.amount)
            : ''
        },
        minWidth: '170px',
        right: true,
        style: tableStyle?.columns?.link || {},
        sortable: false,
        conditionalCellStyles: [
          {
            when: (row) => row.forRole !== 'WITHDRAW',
            style: {
              color: AppColors.primary,
            },
          },
          {
            when: (row) => row.forRole === 'WITHDRAW',
            style: {
              color: AppColors.danger,
            },
          },
        ],
      },
      {
        id: 'BALANCE',
        name: (
          <div className='w-100'>
            <div className="letter-spacing-unset font-weight-bolder"
              style={{
                fontSize: 12,
                color: AppColors.gray[900],
              }}
            >{t('Số dư ví')}</div>
            <div className="letter-spacing-unset font-weight-bold"
              style={{ color: AppColors.gray[700] }}
            >
              VNĐ
            </div>
          </div>
        ),
        sortable: false,
        selector: (row) => row?.endingBalance ? Utils.formatNumber(row?.endingBalance) : '',
        minWidth: '170px',
        right: true,
      },
      {
        id: 'STATUS',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('status')}
          </span>
        ),
        selector: (row) => {
          return (
            <>
              {row?.payment?.status && (
                <KTLabel
                  text={AgencyHelper.Utils.getTransactionStatusName(row?.payment?.status)}
                  isInline={true}
                  size={KTLabelSize.medium}
                  additionalClassName={`label-light-${AgencyHelper.Utils.getTransactionStatusColor(row?.payment?.status)}`}
                />
              )}
            </>
          );
        },
        sortable: false,
        minWidth: '130px',
      },
      {
        id: 'REQUIRED_TIME',
        name: <span className="letter-spacing-unset font-weight-bolder"
          style={{
            fontSize: 12,
            color: AppColors.gray[900],
          }}
        >{t('Thời gian yêu cầu')}</span>,
        selector: (row) => Utils.formatDateTimeToString(row?.createdAt),
        minWidth: '170px',
        sortable: false,
      },
      {
        id: 'PAID_TIME',
        name: <span className="letter-spacing-unset font-weight-bolder"
          style={{
            fontSize: 12,
            color: AppColors.gray[900],
          }}
        >{t('Thời gian thanh toán')}</span>,
        selector: (row) => Utils.formatDateTimeToString(row?.updatedAt),
        minWidth: '170px',
        sortable: false,
      },
      {
        name: <span style={{
          fontSize: 12,
          color: AppColors.gray[900]
        }} className="letter-spacing-unset">{t('Thao tác')}</span>,
        width: '90px',
        wrap: true,
        sortable: false,
        style: {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          borderLeft: '1px solid #ebedfe',
        },
        cell: (row) => (
          <div className="d-flex gap-2">
            <KTTooltip offset={[0, 0]} text={'Xem chi tiết'}>
              <a
                className="btn btn-sm btn-clean btn-icon"
                onClick={() => {
                  handleShowTransactionDetail(row);
                }}
              >
                <i
                  className="fa-regular fa-eye"
                  style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                />
              </a>
            </KTTooltip>
          </div>
        ),
      }
    ];
  }, [t]);

  const prefKey = useMemo(() => {
    const userId = user.userId;
    const pathName = `${router.pathname}${router.location.hash}`;
    return `${userId}_${pathName}`;
  }, [user, router]);

  const [fullColumnIds, setFullColumnIds] = useState(fullColumns?.map((row) => row?.id).filter(Boolean));
  const {
    columnIds,
    columns,
    onChangeCheckboxValue,
    resetDefaultTableColumn,
    saveChanges,
    onSelectAll,
    onUnSelectAll,
    fullColumnsIdSorted
  } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);
  const [timeFilterType, setTimeFilterType] = useState('START_TIME');

  // MARK: ---- methods ----

  const handleFilterChanged = (filter) => {
    if (onFilterChanged) {
      onFilterChanged(filter);
    }
  };

  const handleShowTransactionDetail = (row) => {
    AppCustomDialogHelper.show(
      'Thông tin giao dịch',
      <AgencySaleDialogView
        confirmButtonText={null}
        cancelButtonText="Bỏ qua"
        onCancel={() => {
          AppCustomDialogHelper.hide();
        }}
        onlyBodyEl={true}
        bodyEl={
          <DialogTransactionDetailView
            item={row}
            user={user}
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onDone={() => {
              AppCustomDialogHelper.hide();
              if (onDone) {
                onDone();
              }
            }}
          />
        }
      />,
      'md',
      false,
      true
    );
  };

  // xuat file excel
  const handleExportExcel = async (exportData, params) => {
    let exportDataList = exportData;
    if (_.isEmpty(exportDataList)) {
      ToastHelper.showError('Không có dữ liệu để tải xuống');
      return;
    }

    const sheetFileName = agencyDetail?.agencyCode + '_Lịch_sử_giao_dịch_' + moment(params.from).format('DDMMYYYY') + '_' + moment(params.to).format('DDMMYYYY');
    const ext = '.xlsx';
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet(sheetFileName, {
      headerFooter: { firstHeader: sheetFileName },
    });

    sheet.mergeCells('A1:M1');
    sheet.getCell('A1').value = `LỊCH SỬ GIAO DỊCH ${AgencyHelper.Utils.getShortAgencyRoleName(agencyRole)?.toUpperCase()} ${agencyDetail?.name?.toUpperCase()} (NGÀY ${moment(params.from).format(
      'DD/MM/YYYY'
    )} - ${moment(params.to).format('DD/MM/YYYY')})`;
    sheet.getCell('A1').font = {
      name: 'Times New Roman',
      family: 4,
      size: 11,
      bold: true,
      color: { argb: 'FFFFFFFF' },
    };
    sheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
    sheet.getCell('A1').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '29618E' },
      color: { argb: 'FFFFFF' },
    };
    sheet.getCell('A1').border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    sheet.getRow(1).height = 25;

    const columns = [
      { key: 'stt', width: 7 },
      { key: 'transactionCode', width: 18 },
      { key: 'transactionType', width: 18 },
      { key: 'description', width: 30 },
      { key: 'agencyCode', width: 18 },
      { key: 'bankBeneficiary', width: 30 },
      { key: 'bankAccount', width: 22 },
      { key: 'bankName', width: 22 },
      { key: 'amount', width: 15 },
      { key: 'balance', width: 20 },
      { key: 'status', width: 20 },
      { key: 'createdAt', width: 20 },
      { key: 'finishedTime', width: 20 },
    ];
    sheet.columns = columns;

    sheet.getRow(2).height = 30;
    sheet.getRow(2).font = {
      name: 'Times New Roman',
      family: 4,
      size: 11,
      bold: true,
    };
    sheet.getRow(2).alignment = {
      vertical: 'middle',
      horizontal: 'center',
      wrapText: true,
    };

    sheet.getCell('A2').value = 'STT';
    sheet.getCell('B2').value = 'Mã giao dịch';
    sheet.getCell('C2').value = 'Loại giao dịch';
    sheet.getCell('D2').value = 'Mô tả';
    sheet.getCell('E2').value = 'Mã đại lý';
    sheet.getCell('F2').value = 'Người thụ hưởng';
    sheet.getCell('G2').value = 'Tài khoản thụ hưởng';
    sheet.getCell('H2').value = 'Ngân hàng';
    sheet.getCell('I2').value = 'Số tiền (VNĐ)';
    sheet.getCell('J2').value = 'Số dư ví (VNĐ)';
    sheet.getCell('K2').value = 'Trạng thái';
    sheet.getCell('L2').value = 'Thời gian yêu cầu';
    sheet.getCell('M2').value = 'Thời gian thanh toán';


    ['A2:M2'].forEach((range) => {
      sheet.getRow(range.split(':')[0].slice(1)).eachCell({ includeEmpty: true }, (cell) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    });

    let i = 1;
    exportDataList?.forEach((row) => {
      const dataRow = sheet.addRow({
        stt: i++,
        transactionCode: row?.agencyTransactionCode ?? row?.agencyTransactionId,
        transactionType: row?.forRole ? row.forRole === 'WITHDRAW' ? 'Rút tiền' : 'Cộng tiền' : '',
        description: row?.description,
        agencyCode: agencyDetail?.agencyCode,
        bankBeneficiary: row?.payment?.bankBeneficiary,
        bankAccount: row.forRole !== 'WITHDRAW' ? 'Ví đại lý' : row?.payment?.bankAccount,
        bankName: row?.payment?.bankName,
        amount: Utils.formatNumber(row?.amount ?? 0),
        balance: Utils.formatNumber(row?.endingBalance ?? 0),
        status: AgencyHelper.Utils.getTransactionStatusName(row?.payment?.status),
        createdAt: Utils.formatDateTimeToString(row?.createdAt),
        finishedTime: Utils.formatDateTimeToString(row?.updatedAt),
      });

      dataRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (colNumber === 1) {
          cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        } else if (colNumber >= 9 && colNumber <= 10) {
          cell.alignment = { vertical: 'middle', horizontal: 'right', wrapText: true };
        } else {
          cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
        }
      });
    });

    sheet.eachRow((row, rowNumber) => {
      if (rowNumber >= 3) {
        row.font = {
          name: 'Times New Roman',
          family: 4,
          size: 11,
          bold: false,
        };
      }
    });

    workbook.xlsx.writeBuffer().then(function (data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = sheetFileName + ext;
      anchor.click();
      window.URL.revokeObjectURL(url);
      ToastHelper.showSuccess('Tải xuống file Excel thành công');
      AppCustomDialogHelper.hide();
    });
  };

  return (
    <div>
      {/* header */}
      {showFullUI && (
        <div className="d-flex justify-content-between align-items-center">
          {/* title */}
          <div className="d-flex flex-column align-items-start">
            <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
              Lịch sử giao dịch
            </span>
            <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
              Tổng số:{' '}
              <span style={{ color: AppColors.primary }}>
                {Utils.formatNumber(transactionTotal)} giao dịch
              </span>
            </span>
          </div>
          <div>
            {UIHelper.buildBlueButton(
              'Tải xuống',
              () => { console.log('Tải xuống'); },
              <i className="fa-regular fa-download" style={{ fontSize: 15 }} />
            )}
          </div>
        </div>
      )}

      <div className="w-100 d-flex m-0 pt-4 pb-2 align-items-end">
        {/* tim kiem */}
        <div className="w-25 pl-0 pr-2">
          <label htmlFor="search-bar" className="mb-0 mr-2 font-weight-bolder">
            {t('search')}
          </label>
          <KTFormSearch
            name="search-bar"
            placeholder={t('Theo mã giao dịch, người thụ hưởng...')}
            value={filter.q}
            onSubmit={(text) => {
              handleFilterChanged({
                q: text,
              });
            }}
          />
        </div>

        {/* loc theo loai giao dich*/}
        <div className="w-25 px-2">
          <label htmlFor="status" className="mb-0 mr-2 font-weight-bolder">
            {t('Loại giao dịch')}
          </label>
          <KTBSDropdown
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {transactionTypeOptions.find((item) => item.value === filter.forRole)
                  ?.name ?? t('all')}
              </button>
            }
            selectedValue={filter.forRole}
            dropdownMenuItems={transactionTypeOptions}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              handleFilterChanged({
                forRole: value,
              });
            }}
            isDropdownForm={true}
            direction={showFullUI ? KTBSDropdownDirections.down : KTBSDropdownDirections.up}
          />
        </div>

        <div className="min-w-180px px-2 ml-2 d-flex align-items-end"
          style={{
            borderLeft: `1px solid ${AppColors.gray[300]}`
          }}
        >
          <div className="radio-inline w-100 px-2">
            <div className="d-flex flex-column">
              <KTRadio
                name="startTime"
                label="Thời gian yêu cầu"
                type={KTRadioType.outline}
                additionalClassName="radio-success"
                onChange={() => {
                  setTimeFilterType('START_TIME')
                  handleFilterChanged({
                    dateFilter: dateFilter.baMuoiNgayGanNhat,
                    from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                    to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                  });
                }}
                checked={timeFilterType === 'START_TIME'}
              />
              <KTRadio
                name="endTime"
                label="Thời gian thanh toán"
                type={KTRadioType.outline}
                additionalClassName="radio-success"
                onChange={() => {
                  setTimeFilterType('END_TIME')
                  handleFilterChanged({
                    dateFilter: dateFilter.baMuoiNgayGanNhat,
                    from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                    to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                  });
                }}
                checked={timeFilterType === 'END_TIME'}
              />
            </div>
          </div>
        </div>

        {/* loc theo khoang thoi gian */}
        <div className="w-25 pr-4 mr-4"
          style={{
            borderRight: `1px solid ${AppColors.gray[300]}`
          }}
        >
          {UIHelper.buildFormLabel(timeFilterType === 'START_TIME' ? 'Thời gian yêu cầu' : 'Thời gian thanh toán')}
          <CustomDateRangePicker
            alignRight={true}
            toggleFontWeight="400"
            toggleElementBorderRadius={5}
            initialValue={filter.dateFilter}
            onPressSave={(selectedValue, startDate, endDate) => {
              handleFilterChanged({
                dateFilter: selectedValue,
                from: startDate,
                to: endDate,
              });
            }}
            direction={showFullUI ? KTBSDropdownDirections.down : KTBSDropdownDirections.up}
          />
        </div>

        {/* cau hinh cot */}
        {/* <div className="pl-0 py-2">
          <DropdownTableConfigColumn
            columnIds={columnIds}
            fullColumns={fullColumns}
            fullColumnIds={fullColumnsIdSorted}
            onChangeCheckboxValue={onChangeCheckboxValue}
            saveChanges={saveChanges}
            resetDefaultTableColumn={() => {
              setFullColumnIds(defaultColumnIds);
              resetDefaultTableColumn();
            }}
            onChangeFullColumnIds={(ids) => {
              setFullColumnIds(ids);
              const key = prefKey + '_FULL_COLUMN_IDS';
              localStorage.setItem(key, ids.join('|'));
            }}
            onSelectAll={onSelectAll}
            onUnSelectAll={onUnSelectAll}
            direction={KTBSDropdownDirections.up}
          />
        </div> */}

        {!showFullUI && UIHelper.buildBlueButton(
          'Tải xuống',
          async () => {
            try {
              ChargeHelper.UI.Excel.showDialogDownloadExcelFile(
                filter,
                async (params) => {
                  try {
                    const { transactions = [] } = await agencyCommissionApi.getAgencyCommissionTransactions(params);
                    return handleExportExcel(transactions, params);
                  } catch (error) {
                    ToastHelper.showError(`Lỗi khi lấy dữ liệu: ${error.message}`);
                    return [];
                  }
                },
              );
            } catch (error) {
              ToastHelper.showError(`Lỗi khi khởi tạo tải xuống: ${error.message}`);
            }
          },
          <i className="fa-regular fa-download" />
        )}
      </div>

      {/* body */}
      <div className="mt-4">
        <KTTable
          columns={columns}
          items={transactionList}
          selectableRows={false}
          striped={false}
          compactGrid={false}
          onClickedRow={() => { }}
          onSelectedRowsChanged={(rows) => { }}
          onDoubleClickedRow={(rows) => { }}
          hasActionColumn={true}
          noDataComponent={
            <EmptyView
              icon={imgEmptyNhanVien}
              title="Không có dữ liệu để hiển thị"
              text={
                <div className="text-center">
                  <span>
                    Hiện không có dữ liệu để hiển thị. Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.
                  </span>
                </div>
              }
            />
          }
        />
      </div>

      {/* phan trang */}
      {!_.isEmpty(transactionList) && (
        <div className="mt-4">
          <KTPagination
            currentPage={filter.page + 1}
            rowCount={transactionTotal}
            rowsPerPage={filter.limit}
            currentItemInPageCount={transactionList.length}
            onChangePage={(newPage) => {
              const iNewPage = parseInt(newPage);
              handleFilterChanged({
                page: iNewPage - 1,
              });
            }}
            onChangeRowsPerPage={(newRowsPerPage) => {
              const iNewRowsPerPage = parseInt(newRowsPerPage);
              handleFilterChanged({
                limit: iNewRowsPerPage,
                page: 0,
              });
            }}
            loading={false}
            color={KTPaginationColor.success}
            appendText="giao dịch"
          />
        </div>
      )}

    </div>
  );
}

export default TransactionHistoryView;
